import { SRMultiStylesSchema } from './SRMulti.styles';

export const srMultiStyles: SRMultiStylesSchema = {
  multiContainer: {
    mx: '4',
    p: '2',
    bg: '#495564',
    borderRadius: 'md',
    mb: '2',
  },
  multiRunnerContainer: {
    justifyContent: 'space-between',
    bgGradient: 'linear(to-b, beta.600, beta.700)',
    p: '3',
    my: '2',
    borderRadius: 'md',
  },
  buttonLabel: {
    color: 'white',
  },
  propButton: {
    w: '50px',
  },
  columnHeadings: {
    w: '50px',
    textAlign: 'center',
    fontSize: 'xs',
    color: 'white',
  },
  headingLabel: {
    color: 'white',
    fontSize: 'xs',
  },
  headingContainer: {
    textAlign: 'center',
    textTransform: 'capitalize',
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'medium',
    marginRight: '1',
  },
  contentContainer: {
    px: '4',
  },
  runnerList: {
    p: '2',
    border: '2px',
    borderColor: 'gamma.500',
    bg: 'alpha.500',
    borderRadius: 'lg',
  },
};
